/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Structured feedback data
 * @export
 * @interface AddFeedbackInput
 */
export interface AddFeedbackInput {
    /**
     * Type of feedback (e.g., THUMBS_UP_DOWN, QUALITY_RATING, etc.)
     * @type {string}
     * @memberof AddFeedbackInput
     */
    feedbackType?: string;
    /**
     * Rating value (e.g., THUMBS_UP, FIVE_STARS, etc.)
     * @type {string}
     * @memberof AddFeedbackInput
     */
    rating?: string;
    /**
     * Optional comment or description for the feedback
     * @type {string}
     * @memberof AddFeedbackInput
     */
    comment?: string;
    /**
     * Additional metadata for the feedback
     * @type {{ [key: string]: any; }}
     * @memberof AddFeedbackInput
     */
    metadata?: { [key: string]: any; };
}

/**
 * Check if a given object implements the AddFeedbackInput interface.
 */
export function instanceOfAddFeedbackInput(value: object): value is AddFeedbackInput {
    return true;
}

export function AddFeedbackInputFromJSON(json: any): AddFeedbackInput {
    return AddFeedbackInputFromJSONTyped(json, false);
}

export function AddFeedbackInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFeedbackInput {
    if (json == null) {
        return json;
    }
    return {
        
        'feedbackType': json['feedbackType'] == null ? undefined : json['feedbackType'],
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function AddFeedbackInputToJSON(json: any): AddFeedbackInput {
    return AddFeedbackInputToJSONTyped(json, false);
}

export function AddFeedbackInputToJSONTyped(value?: AddFeedbackInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feedbackType': value['feedbackType'],
        'rating': value['rating'],
        'comment': value['comment'],
        'metadata': value['metadata'],
    };
}

